import _ from 'lodash'
import axios from 'axios'

export default {
  setup (store) {
    const cancelToken = this.getCancelToken()
    store.commit('setCancelToken', cancelToken)

    // setup request interceptors
    axios.interceptors.request.use(
      (config) => {
        // console.log(config)
        // config.cancelToken = store.state.cancelToken.token
        config.headers = {
          'Authorization': `Bearer ${store.state.apiToken}`,
          'X-CSRF-TOKEN': store.state.csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        }
        return config
      },
      (error) => {
        Promise.reject(error)
      }
    )

    // setup response interceptors
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response) {
          if (error.response.status === 419) {
            // invalid csrf
            const originalRequest = error.config
            if (!originalRequest._retry) {
              // refresh csrf
              await store.dispatch('refreshCsrfToken')
              return axios.request(originalRequest)
            } else {
              alert('There was an issue validating your request, make sure you do not have this application open in another window.')
            }
          } else if (error.response.status === 401) {
            // auth error, redirect to login
            // window.location.href = '/login';
            console.error('Authentication Error', error)
            $('#session-expired-modal').modal()
          }
        }

        return Promise.reject(error)
      }
    )
  },
  getCancelToken: () => axios.CancelToken.source(),
  async toggleFavorite (id, value) {
    try {
      const response = await axios.post(`/projects/${id}/favorite`, { toggle: value })
      return _.get(response, 'data.status') === 'success'
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async getCsrfToken () {
    try {
      const response = await axios.get('/refresh')
      return _.get(response, 'data.csrf_token')
    } catch (err) {
      console.error(err)
    }
    return false
  }
}